import { BodyOf, defineRoute, defineRoute$, QueryOf, ResponseOf } from "./typedRoute";
import type { ProductCollectionItem } from "./types";
import type { IUserinfo } from "@store/index";

export const fetchProductList = defineRoute("GET/api/focus/products-collection").as<ProductCollectionItem[]>();

export const fetchCreateOption = defineRoute("GET/api/video/creation-option");
export type FetchCreateOptionResponse = NonNullable<ResponseOf<"GET/api/video/creation-option">>;

export const fetchParseProductImages = defineRoute("POST/api/product/parse-info-by-id", {
  timeoutMs: 180_000,
});
export type FetchParseProductImagesResponse = ResponseOf<"POST/api/product/parse-info-by-id">;

export const getProfile = defineRoute("GET/api/users/profile", { context: { silent: true } }).as<IUserinfo>();

/** 获取授权登录url */
export const creatorAuthUrl = defineRoute("GET/api/tiktok-shop/creator-auth-url");

/** 分页查询用户可选产品列表 */
export const listAccountProducts = defineRoute("GET/api/tiktok-shop/account-products");

/** 关联账号列表 */
export const getLinkAccounts = defineRoute("GET/api/users/link/accounts");

/** 解绑关联账号 */
export const userLinkUnbind = defineRoute("POST/api/users/link/unbind");

/** 提交视频发布 */
export const submitPublish = defineRoute("POST/api/users/publish/submit");
export type SubmitPublishResponse = ResponseOf<"POST/api/users/publish/submit">;
export type UserPublishSubmitRequest = BodyOf<"POST/api/users/publish/submit">;

/** 确认视频发布 */
export const confirmPublish = defineRoute("POST/api/users/publish/confirm");

/** 查询视频发布结果 */
export const queryPublishResult = defineRoute("GET/api/users/publish/result");
export type UserPublishResultResponse = ResponseOf<"GET/api/users/publish/result">;

/** 分页查询视频发布记录 */
export const queryPublishPage = defineRoute("GET/api/users/publish/page");
export const queryPublishPage$ = defineRoute$("GET/api/users/publish/page");
export type UserPublishPageRequest = NonNullable<Parameters<typeof queryPublishPage>[0]>;
export type PublishPageResponse = ResponseOf<"GET/api/users/publish/page">;

/** 取消预约发布 */
export const cancelPublish = defineRoute("POST/api/users/publish/cancel");

/** 查询视频关联的产品信息 */
export const queryAssetProductInfo = defineRoute("GET/api/tiktok-shop/asset-product");
export type AssetProductInfoResponse = ResponseOf<"GET/api/tiktok-shop/asset-product">;

/** 分页查询用户可选产品列表 */
export const queryAccountProductList = defineRoute("GET/api/tiktok-shop/account-products");

/** 生成商品属性（卖点） */
export const generateProductSellingPoints = defineRoute("POST/api/product/attribute");

// 自定义商品：根据图片和关键词推断卖点
export const getInferSellingPoints = defineRoute("POST/api/product/infer-selling-point", { timeoutMs: 120_1000 });

export const clipLogin = defineRoute("POST/api/login");

export const getPreviewVideoCredit = defineRoute("POST/api/video/creation/credit-preview");

export const getUserAssets = defineRoute("GET/api/users/assets");
export type UserAssetsQuery = NonNullable<QueryOf<"GET/api/users/assets">>;
/** 视频生成列表查询参数（assetType、assetSource 在 thunk 内固定为 VID、AI） */
export type FetchVideoGenerateListParams = Omit<UserAssetsQuery, "assetType" | "assetSource">;
export type UserAssetsPageResponse = NonNullable<ResponseOf<"GET/api/users/assets">>;
export type UserAssetRecord = NonNullable<NonNullable<UserAssetsPageResponse>["data"]>[number];

/** 上传用户手动选择的 mp4/mov 视频（最大 100MB） */
export const uploadUserVideo = defineRoute("POST/api/user-assets/upload-video");
export type UploadUserVideoResponse = ResponseOf<"POST/api/user-assets/upload-video">;

export const videoGenerateStatus = defineRoute("POST/api/video/script-generate");
export type VideoGenerateStatusRequest = BodyOf<"POST/api/video/script-generate">;

export const getVideoCreationJobDetail = defineRoute("GET/api/video/creation/job-detail");
